import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {Offset} from '../../../models/Offset';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {ConsuntivoChargesModel} from '../../../models/ConsuntivoChargesModel';
import {ConsuntivoChargesService} from './service-consuntivo-charges/consuntivo-charges.service';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {Router} from '@angular/router';
import {ProviderModel} from '../../../models/ProviderModel';
import {ContractTypeService} from '../../general-services/service-contract-type/contract-type.service';
import {UsersService} from '../../users/service/users.service';

@Component({
  selector: 'app-consuntivo-charges',
  templateUrl: './consuntivo-charges.component.html',
  styleUrls: ['./consuntivo-charges.component.scss']
})
export class ConsuntivoChargesComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: any;
  isConsumptiveSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;

  offset: Offset;
  filter: ConsuntivoChargesModel;
  numAnnoMeseData: any;
  contractTypeData: any;
  showFilter: boolean;

  providerSelected: ProviderModel;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() isRecovery: number;
  @Input() reportSection?: boolean;

  @Output() elementSelected = new EventEmitter();

  constructor(private consuntivoChargesService: ConsuntivoChargesService,
              private numAnnoMeseService: NumAnnoMeseService,
              private contractTypeService: ContractTypeService,
              private userService: UsersService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.sectionId = this.SECTIONS.MONTHLY_CHARGES;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.loaderService.display(true);
  }

  ngOnInit() {
    this.isConsumptiveSection = this.returnIsContractSection(this.router.url);
    this.providerSelected = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
    this.selectedRowIndex = -1;
    this.showFilter = false;

    if (this.providerSelected.description === this.PROVIDER_IBM) {
      this.displayedColumns = ['numAnnoMeseRif', 'regionDesc', 'localCustomerDesc',
        'contractTypeDesc', 'resourceUnitCod', 'resourceUnitName', 'charge', 'actions'];
    } else {
      this.displayedColumns = ['numAnnoMeseRif', 'numAnnoMeseAcceptance', 'residualMonth',
        'regionDesc', 'localCustomerDesc', 'contractTypeDesc',
        'resourceUnitCod', 'resourceUnitName', 'serviceVariantCod', 'percUse', 'charge', 'notes', 'actions'];
    }
    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.CONSUMPTIVE_CHARGES_OFFSET);
    this.getSessionStorageFilter();
    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.init();
  }

  init() {
    this.filter.isRecovery = this.isRecovery;

    this.numAnnoMeseService.getAllMonth(this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        this.numAnnoMeseData = resultYearMonth;

        if (!this.filter.numAnnoMese || !BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
          const numAnnoMese = resultYearMonth[0] ? resultYearMonth[0] : null;
          this.filter.numAnnoMese = numAnnoMese;
        }

        if (!this.reportSection) {
          this.showFilter = false;
          this.getDataPage(this.offset, this.filter);
        } else {
          this.showFilter = true;
        }          }, error => {
        console.log(error);
        this.loaderService.display(false);
      });
  }

  getDataPage(offset: Offset, filter: ConsuntivoChargesModel) {
    this.getPageSubscribe = this.consuntivoChargesService.getPage(offset, filter)
      .subscribe(
        (resultPage: any) => {
          this.dataSource = resultPage.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = resultPage.totalElements;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    const consuntivoCharges = this.dataSource.find(data => data.id === id) as ConsuntivoChargesModel;
    const list: GenericArray[] = [
      {id: 'Month', value: this.toCustomStringAnnoMese(consuntivoCharges.numAnnoMese)},
      {id: 'Reference Month', value: this.toCustomStringAnnoMese(consuntivoCharges.numAnnoMeseRif)},
      {id: 'Provider Cod', value: this.toCustomString(consuntivoCharges.provider.cod)},
      {id: 'Provider Description', value: this.toCustomString(consuntivoCharges.provider.description)},
      {id: 'Region Cod', value: this.toCustomString(consuntivoCharges.region.cod)},
      {id: 'Region Description', value: this.toCustomString(consuntivoCharges.region.description)},
      {id: 'Local Customer Cod', value: this.toCustomString(consuntivoCharges.localCustomer.cod)},
      {id: 'Local Customer Description', value: this.toCustomString(consuntivoCharges.localCustomer.description)},
      {id: 'Contract Type Cod', value: this.toCustomString(consuntivoCharges.contractType.description)},
      {id: 'Contract Type Description', value: this.toCustomString(consuntivoCharges.contractType.description)},
      {id: 'Resource Unit Cod', value: this.toCustomString(consuntivoCharges.resourceUnit.cod)},
      {id: 'Resource Unit Name', value: this.toCustomString(consuntivoCharges.resourceUnit.name)},
      {id: 'ConsumptiveCharge', value: this.toCustomString(consuntivoCharges.charge)},
      {id: 'ServiceVariant', value: this.toCustomString(consuntivoCharges.serviceVariant.cod)},
      {id: 'Is Recovery', value: this.toCustomStringIs(consuntivoCharges.isRecovery)},
    ];


    if (this.providerSelected.description === this.PROVIDER_DXC) {
      list.push({id: 'Notes', value: this.toCustomString(consuntivoCharges.notes)});
    }
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });
  }


  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.CONTRACTUAL_VALUES_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);
  }

  getDataFiltered(dataFiltered: any) {
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.filter = dataFiltered;
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }

    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
    }
  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.CONSUMPTIVE_CHARGES_FILTER));
    this.filter = filter_ ? filter_ : new ConsuntivoChargesModel();
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
  }
}
